const BASE_USERS_ACTION = "USERS/";
export const SET_USERS_DATA = `${BASE_USERS_ACTION}/SET_USERS_DATA`;
export const ADD_USER_SUCCESS = `${BASE_USERS_ACTION}/ADD_USER_SUCCESS`;
export const DELETE_USER_SUCCESS = `${BASE_USERS_ACTION}/DELETE_USER_SUCCESS`;
export const EDIT_USER_SUCCESS = `${BASE_USERS_ACTION}/EDIT_USER_SUCCESS`;
export const SET_USER_ROLES = `${BASE_USERS_ACTION}/SET_USER_ROLES`;
export const SET_SYSTEMS_LIST = `${BASE_USERS_ACTION}/SET_SYSTEMS_LIST`;
